/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors, flex, measure, TOUCH_TARGET } from "../styles"

export const MenuButton = ({ toggled, onClick: handleToggle, ...props }) => {
  return (
    <button
      type="button"
      css={[
        {
          ...flex("column"),
          alignItems: "center",
          justifyContent: "space-around",
          // width: "100%",
          // height: "100%",
          height: TOUCH_TARGET,
          width: TOUCH_TARGET,
          padding: measure.THICK_BORDER,

          cursor: "pointer",
          border: 0,

          backgroundColor: "transparent",
          borderRight: `solid ${colors.BLUE} ${measure.THIN_BORDER}`,
          borderBottom: `solid ${colors.BLUE} ${measure.THIN_BORDER}`,
        },
        toggled
          ? { borderColor: colors.PAPER_WHITE }
          : { borderColor: colors.BLUE },
      ]}
      onClick={handleToggle}
      {...props}
    >
      <div
        css={[
          {
            width: "100%",
            height: measure.THIN_BORDER,

            backgroundColor: colors.BLUE,
          },
          toggled && { backgroundColor: colors.PAPER_WHITE },
        ]}
      ></div>
      <div
        css={[
          {
            backgroundColor: colors.BLUE,
            width: "100%",
            height: measure.THIN_BORDER,
          },
          toggled && { backgroundColor: colors.PAPER_WHITE },
        ]}
      ></div>
    </button>
  )
}
